import * as React from "react";

function SvgFileLock({ title, titleId, ...props }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h24v24H0z" />
        <path
          fill="currentColor"
          d="M14.172 2.25c.663 0 1.301.24 1.8.67l.144.136 2.828 2.828c.47.468.751 1.09.799 1.746l.007.198V11a.75.75 0 01-1.493.102L18.25 11V8.75H15a1.75 1.75 0 01-1.744-1.607L13.25 7V3.75H7a1.25 1.25 0 00-1.244 1.122L5.75 5v14c0 .648.491 1.18 1.122 1.244L7 20.25h4a.75.75 0 01.102 1.493L11 21.75H7a2.75 2.75 0 01-2.745-2.582L4.25 19V5a2.75 2.75 0 012.582-2.745L7 2.25h7.172zm2.912 11c1.235 0 2.264.997 2.348 2.196l.005.157v1.005a1.406 1.406 0 011.313 1.403v2.33a1.405 1.405 0 01-1.405 1.409h-4.521c-.777 0-1.407-.63-1.407-1.406v-2.333c0-.777.63-1.406 1.406-1.406l-.093.004.001-1.006c0-1.3 1.053-2.353 2.353-2.353zm2.166 4.855h-4.334v2.144h4.334v-2.144zm-2.166-3.355a.852.852 0 00-.846.746l-.007.107-.001 1.002h1.706l.001-1.002c0-.446-.4-.853-.853-.853zM14.751 3.893L14.75 7a.25.25 0 00.193.243L15 7.25h3.108a1.246 1.246 0 00-.13-.2l-.094-.106-2.828-2.828a1.233 1.233 0 00-.305-.223z"
        />
      </g>
    </svg>
  );
}

export default SvgFileLock;
